import type { Review } from "@/types/media";

export const reviewList: Review[] = [
  {
    id: "r1",
    mediaId: "1",
    nickname: "夜航的灯塔",
    avatarSeed: "av-01",
    rating: 9.2,
    content:
      "看得我头皮发麻。那种被宇宙的寂静包裹住的感觉，很难用语言形容。全片没有一句多余的台词，最后一个镜头出来的时候，全场安静了好几秒。",
    date: "2026-03-20",
  },
  {
    id: "r2",
    mediaId: "1",
    nickname: "小行星带居民",
    avatarSeed: "av-02",
    rating: 8.8,
    content: "硬核但不说教，情感落点非常准。配乐加分太多，建议去影院感受环绕声。",
    date: "2026-03-18",
  },
  {
    id: "r3",
    mediaId: "1",
    nickname: "月亮背面",
    avatarSeed: "av-03",
    rating: 8.5,
    content: "中段稍慢，但越往后越上头。关于“归乡”的隐喻写得很高级。",
    date: "2026-03-16",
  },
  {
    id: "r4",
    mediaId: "2",
    nickname: "雨夜打工人",
    avatarSeed: "av-04",
    rating: 8.6,
    content: "张赫铭这次的表演太克制了，全靠眼神。雨戏拍得尤其压抑，看完之后不敢在夜里一个人走小巷。",
    date: "2025-11-15",
  },
  {
    id: "r5",
    mediaId: "2",
    nickname: "熬夜冠军",
    avatarSeed: "av-05",
    rating: 8.3,
    content: "剧本扎实，线索回收得很干净。国产犯罪片近几年最好的一批。",
    date: "2025-11-12",
  },
  {
    id: "r6",
    mediaId: "12",
    nickname: "海边的风",
    avatarSeed: "av-06",
    rating: 9.4,
    content: "哭到纸巾不够用。画面美到每一帧都想截图，故事温柔得让人心疼。带妈妈一起看，她也红了眼眶。",
    date: "2025-08-30",
  },
  {
    id: "r7",
    mediaId: "24",
    nickname: "追光者",
    avatarSeed: "av-07",
    rating: 8.7,
    content: "国产奇幻终于有像样的世界观了！服化道和取景太用心，云海城市的设计惊艳到我。",
    date: "2026-05-20",
  },
  {
    id: "r8",
    mediaId: "24",
    nickname: "云上散步",
    avatarSeed: "av-08",
    rating: 8.5,
    content: "世界观立得住，人物也写得好，不是单纯堆特效的剧。已经安利给全办公室了。",
    date: "2026-05-18",
  },
  {
    id: "r9",
    mediaId: "15",
    nickname: "时间管理员",
    avatarSeed: "av-09",
    rating: 9.0,
    content: "看第二遍才发现前面埋了好多细节。逻辑自洽，情感又很戳人，年度最佳科幻之一。",
    date: "2026-04-22",
  },
  {
    id: "r10",
    mediaId: "7",
    nickname: "星际旅人",
    avatarSeed: "av-10",
    rating: 8.6,
    content: "单元剧形式但每集质量都很稳，治愈又带点哲学。适合下班后慢慢看。",
    date: "2025-05-20",
  },
  {
    id: "r11",
    mediaId: "26",
    nickname: "琴键上的猫",
    avatarSeed: "av-11",
    rating: 9.1,
    content: "作为古典乐爱好者，几场演奏戏拍得我起鸡皮疙瘩。最后一个音符落下时，真的屏住了呼吸。",
    date: "2026-06-25",
  },
  {
    id: "r12",
    mediaId: "14",
    nickname: "北漂第七年",
    avatarSeed: "av-12",
    rating: 8.4,
    content: "太真实了，几乎每个细节都能对上自己的生活。没有逆袭，只有咬牙坚持，反而更打动人。",
    date: "2025-04-10",
  },
];

export const newsList = [
  {
    id: "n1",
    mediaId: "1",
    title: "《星际回声》口碑爆棚：硬核科幻也能讲好一个关于归乡的故事",
    summary: "上映首周即收获高分评价，导演艾伦·沃德接受采访时表示，影片真正想讨论的是孤独与和解。",
    time: "2026-03-18",
  },
  {
    id: "n2",
    mediaId: "24",
    title: "《云上之城》定档：东方奇幻如何构建一个可信的架空世界",
    summary: "从飞行船到云兽，制作团队首次公开世界观设定手稿，揭秘这座天空之城的诞生过程。",
    time: "2026-05-06",
  },
  {
    id: "n3",
    mediaId: "15",
    title: "《时间褶皱》导演访谈：我拍的不是穿越，而是告别",
    summary: "亨利·阿什克罗夫特谈影片中反复出现的螺旋走廊意象，以及他眼中真正的时间是什么。",
    time: "2026-04-15",
  },
  {
    id: "n4",
    mediaId: "12",
    title: "《少女与海》幕后：每一帧手绘背后，是三年的坚持",
    summary: "动画团队分享了那些会发光的海浪是如何一笔一笔画出来的，以及配乐与画面的配合细节。",
    time: "2025-08-25",
  },
  {
    id: "n5",
    mediaId: "4",
    title: "《山海拾遗》：把《山海经》搬上荧幕，需要多少考据",
    summary: "剧组走访多地古籍馆，从异兽造型到服饰纹样，力求在想象与传统之间找到平衡。",
    time: "2026-01-10",
  },
  {
    id: "n6",
    mediaId: "9",
    title: "《铁血黎明》幕后特辑：一场戏拍了二十一天",
    summary: "主创还原山口守卫战拍摄现场，讲述如何在真实与戏剧之间把握战争的重量。",
    time: "2025-09-01",
  },
  {
    id: "n7",
    mediaId: "20",
    title: "《量子恋人》：当科学遇上浪漫，平行世界里的爱还成立吗",
    summary: "编剧团队聊创作初衷，探讨一个假设背后关于选择与必然的温柔命题。",
    time: "2026-02-26",
  },
  {
    id: "n8",
    mediaId: "3",
    title: "《雾都谜案》第二季确认续订，原班人马回归",
    summary: "制作方宣布新一季将继续探索雾都背后的故事，女探员艾米莉亚的过去将成为核心线索。",
    time: "2024-12-02",
  },
];